import { FileWithPath } from "@mantine/dropzone";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { colors } from "#app/theme/v1/colors";
import { fontSizes } from "#app/theme/v1/fontSizes";
import { SimilarPartFiltersSection } from "#modules/similarPart/view/filters/SimilarPartFiltersSection";
import { SimilarPartDropzoneSection } from "#modules/similarPart/view/SimilarPartDropzoneSection";
import { ROUTES } from "#shared/routes";
import { Flex } from "#shared/view/components/Flex";
import { Group } from "#shared/view/components/Group";
import { Text } from "#shared/view/components/Text";
import { FilterQuery } from "shared";

type Props = {
  progress: number;
  uploadFile: (files: FileWithPath[]) => Promise<void>;
  is3dSearchLoading: boolean;
  onChangeFilters: (params: FilterQuery) => void;
  filtersParams: FilterQuery;
};

export const ResearchSection = ({
  progress,
  uploadFile,
  is3dSearchLoading: isLoading,
  onChangeFilters,
  filtersParams,
}: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const manualSearch = (params: FilterQuery) => {
    navigate(ROUTES.partnerSearch, { state: { filtersParams: params } });
  };

  return (
    <Flex direction="column" justify="center" align={"center"}>
      <SimilarPartDropzoneSection
        title={t("similarPart.dropzone.title")}
        progress={progress}
        uploadFile={uploadFile}
        isLoading={isLoading}
      />

      <Group justify="center" align="center" mt="xs" mb="xs">
        <div style={{ width: 35, height: 1, backgroundColor: colors.gray[5] }} />
        <Text size="sm" c={colors.gray[5]} fz={fontSizes.medium}>
          {"OU"}
        </Text>
        <div style={{ width: 35, height: 1, backgroundColor: colors.gray[5] }} />
      </Group>
      <SimilarPartFiltersSection
        onSubmit={(data) => {
          onChangeFilters(data);
          manualSearch(data);
        }}
        filtersParams={filtersParams}
      />
    </Flex>
  );
};
